module.exports = __webpack_public_path__ + "img/prestado-logo.56d43a14.png";